const MISSIONS = [
  {
    name: "Reprise en main d'une DSI",
    desc: "Direction par intérim, cadrage des priorités, remise sous contrôle des engagements pris envers le métier.",
  },
  {
    name: "Stabilisation d'un système d'information",
    desc: "Sécurisation de l'exploitation, traitement de la dette critique, restauration d'un service fiable et prévisible.",
  },
  {
    name: "Transformation & programmes critiques",
    desc: "ERP, cloud, refonte applicative : tenue du cap, des coûts et des délais sur les programmes à fort enjeu.",
  },
  {
    name: "Cybersécurité, crise & continuité d'activité",
    desc: "Réponse à incident, pilotage post-attaque, plans de continuité et de reprise testés (CISSP, ISO 27001).",
  },
  {
    name: "Gouvernance IT",
    desc: "Comitologie, instances de décision, indicateurs lisibles, relation DG/Métiers/DSI clarifiée.",
  },
];

export default function Missions() {
  return (
    <section
      id="missions"
      data-testid="missions-section"
      className="py-24 sm:py-36 px-6 sm:px-10 lg:px-16 bg-[#F0ECE1]"
    >
      <div className="max-w-7xl mx-auto grid lg:grid-cols-12 gap-12 lg:gap-20">
        <div className="lg:col-span-4 reveal lg:sticky lg:top-32 self-start">
          <p className="eyebrow flex items-center mb-6">
            <span className="gold-line" />
            Ce que je prends en charge
          </p>
          <h2 className="font-serif font-light text-4xl sm:text-5xl text-[#0B132B] leading-[1.1] mb-6">
            Ce sur quoi <span className="italic">je suis attendu.</span>
          </h2>
          <p className="text-[#4A5568] leading-relaxed font-light">
            Des missions courtes ou longues, en direct au comex ou en
            renfort d'une équipe en place. Toujours avec un mandat clair
            et un livrable mesurable.
          </p>
        </div>

        <div className="lg:col-span-8">
          <ul className="divide-y divide-[#E2DCD0] border-t border-b border-[#E2DCD0]">
            {MISSIONS.map((m, i) => (
              <li
                key={m.name}
                data-testid={`mission-item-${i}`}
                className="reveal group py-8 grid sm:grid-cols-12 gap-4 sm:gap-8 items-baseline"
                style={{ transitionDelay: `${i * 50}ms` }}
              >
                <span className="sm:col-span-1 font-serif italic text-[#C8A97E] text-xl">
                  0{i + 1}
                </span>
                <h3 className="sm:col-span-4 font-serif text-2xl text-[#0B132B] leading-tight">
                  {m.name}
                </h3>
                <p className="sm:col-span-7 text-[#4A5568] leading-relaxed font-light">
                  {m.desc}
                </p>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
